/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

import Vue from 'vue';
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import Vuex from 'vuex'
Vue.use(Vuex)

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

Vue.component('data-grid', require('./components/Grid/Grid.vue').default);
Vue.component('data-grid-row', require('./components/Grid/GridRow.vue').default);
Vue.component('brand-select', require('./components/Grid/Controls/BrandSelect.vue').default);
Vue.component('country-select', require('./components/Grid/Controls/CountrySelect.vue').default);
Vue.component('commit-button', require('./components/Grid/Controls/CommitButton.vue').default);
Vue.component('add-new-version', require('./components/Grid/Controls/AddNewVersion.vue').default);
Vue.component('tools-button', require('./components/Grid/Controls/ToolsButton').default);
Vue.component('confirm-data-check', require('./components/Grid/Controls/ConfirmDataCheck').default);
Vue.component('archive-button', require('./components/ArchiveButton').default);
Vue.component('open-media-url', require('./components/OpenMediaUrl').default);
Vue.component('kanban-board', require('./components/Dashboard/KanbanBoard').default);
Vue.component('kanban-item', require('./components/Dashboard/KanbanItem').default);
Vue.component('rating', require('./components/Dashboard/Rating').default);

Vue.component('input-id', require('./components/Grid/InputId.vue').default);
Vue.component('input-gid', require('./components/Grid/InputGid.vue').default);
Vue.component('input-date', require('./components/Grid/InputDate.vue').default);
Vue.component('input-category', require('./components/Grid/InputCategory.vue').default);
Vue.component('input-number', require('./components/Grid/InputNumber.vue').default);
Vue.component('input-text', require('./components/Grid/InputText.vue').default);
Vue.component('data-select', require('./components/Grid/DataSelect.vue').default);

Vue.component('menu-user', require('./components/Nav/MenuUser.vue').default);

Vue.component('research-price-checklist', require('./components/Reports/ResearchPriceChecklist.vue').default);
Vue.component('table-row-header', require('./components/Reports/TableRowHeader.vue').default);
Vue.component('table-row-content', require('./components/Reports/TableRowContent.vue').default);

Vue.component('help-modal', require('./components/Grid/HelpModal.vue').default);

/** Disable toolbox after VAT change has been executed (remove from GridRow.vue as well) */
Vue.component('toolbox', require('./components/Grid/Controls/ToolboxVat2021DE').default);
Vue.component('json-viewer', require('./components/Tools/JsonViewer').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import GridItem from './models/GridItem';

const store = new Vuex.Store({
    state: {
        dates: [],
        categories: [],
        gridItems: []
    },
    mutations: {
        setGridItems (state, gridItems) {
            state.gridItems = gridItems.map(item => {
                return new GridItem(item);
            });
        },
        updateGridItem (state, args)
        {
            const gridItemIndex = args[0];
            const property = args[1];
            const value = args[2];

            state.gridItems[gridItemIndex].update(property, value);
            // console.log(state.gridItems[gridItemIndex]);
        },
        setDates (state, dates) {
            state.dates = [];
            state.dates = [...new Set(dates)].sort().reverse();
        },
        setCategories (state, categories) {
            state.categories = [];
            state.categories = [...new Set(categories)].sort().reverse();
        }
    }
});

const app = new Vue({
    el: '#app',
    store,
    data: {
        enableCommit: false,
        HELP_TOPIC: '',
    }
});
